<script>
  import Icon from "../common/Icon.svelte";
</script>

<div class="text-center py-12">
  <Icon name="document" class="w-12 h-12 mx-auto text-gray-400 mb-4" />
  <p class="text-gray-400">Aucun événement d'audit enregistré</p>
</div>